import "./svg/package-icon.svg"

export default {
    name: "package-icon",
    viewBox: "48 48",
}
